module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/chicken-star1.0c626ec2.png";